import { createAsyncThunk } from '@reduxjs/toolkit';

import { namespace } from '@/modules/car/namespace';
import { getAllCars, getCarForm } from '@/modules/car/store/selectors';
import type { RootState } from '@/root-store';

import { prepareCarForm } from './prepare-car-form';

interface IParams {
  carId?: string;
}

const reloadFormForCurrentCar = createAsyncThunk(
  `${namespace}/reload-form-for-current-car`,
  async ({ carId }: IParams, { dispatch, getState }) => {
    const formCarId = getCarForm(getState() as RootState).id;
    const firstCarId = getAllCars(getState() as RootState)[0]?.id;

    await dispatch(prepareCarForm({ carId: carId || formCarId || firstCarId })).unwrap();
  },
);

export { reloadFormForCurrentCar };
